// AmbientDust — site-wide drifting gold dust + sparkles overlay.
// Mounted ONCE at App root so every route gets the same hypnotic shimmer.
// Pure CSS-driven, deterministic seeds, pointer-events:none, prefers-reduced-motion safe.

const DUST_SEEDS = [
  { left:  4, top: 12, size: 2.5, hue: 'gold',   dur: 38, delay: 0,  dx: -22, dy: -16 },
  { left: 12, top: 78, size: 3,   hue: 'violet', dur: 44, delay: 4,  dx:  28, dy: -28 },
  { left: 21, top: 22, size: 2,   hue: 'gold',   dur: 42, delay: 7,  dx: -18, dy: -32 },
  { left: 28, top: 56, size: 2.8, hue: 'pearl',  dur: 48, delay: 2,  dx:  24, dy: -22 },
  { left: 35, top: 8,  size: 2.5, hue: 'gold',   dur: 46, delay: 11, dx: -26, dy: -34 },
  { left: 43, top: 84, size: 3,   hue: 'violet', dur: 40, delay: 5,  dx:  20, dy: -20 },
  { left: 51, top: 32, size: 2,   hue: 'gold',   dur: 50, delay: 9,  dx: -30, dy: -28 },
  { left: 58, top: 64, size: 2.8, hue: 'pearl',  dur: 36, delay: 1,  dx:  18, dy: -32 },
  { left: 66, top: 18, size: 2.5, hue: 'gold',   dur: 44, delay: 13, dx: -22, dy: -24 },
  { left: 73, top: 72, size: 3,   hue: 'violet', dur: 42, delay: 6,  dx:  26, dy: -30 },
  { left: 81, top: 28, size: 2,   hue: 'gold',   dur: 46, delay: 10, dx: -16, dy: -22 },
  { left: 88, top: 60, size: 2.8, hue: 'pearl',  dur: 48, delay: 3,  dx:  20, dy: -26 },
  { left: 96, top: 14, size: 2.5, hue: 'gold',   dur: 40, delay: 8,  dx: -24, dy: -34 },
  { left:  8, top: 50, size: 2.2, hue: 'gold',   dur: 52, delay: 12, dx: -20, dy: -18 },
  { left: 40, top: 44, size: 2,   hue: 'violet', dur: 46, delay: 14, dx:  22, dy: -28 },
  { left: 70, top: 50, size: 2.5, hue: 'gold',   dur: 44, delay: 15, dx: -18, dy: -24 },
];

export const AmbientDust = () => (
  <div className="ambient-dust" aria-hidden="true">
    {DUST_SEEDS.map((d, i) => (
      <span
        key={`ad-${i}`}
        className={`ambient-dust-mote ambient-dust-mote-${d.hue}`}
        style={{
          left:   `${d.left}vw`,
          top:    `${d.top}vh`,
          width:  `${d.size}px`,
          height: `${d.size}px`,
          '--d-dur':   `${d.dur}s`,
          '--d-delay': `${d.delay}s`,
          '--d-dx':    `${d.dx}vw`,
          '--d-dy':    `${d.dy}vh`,
        }}
      />
    ))}
  </div>
);

export default AmbientDust;
